export default function getVideoDetailInfoUrl() {
    let jmID = window.location.pathname.split("/")[3];
    
    let videoDetailInfo = `/api/videos/${jmID}/details/`;
  
    return videoDetailInfo;
  }